import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ParticipantService} from '../../../service/participant.service';
import {Participant} from '../../../model/Participant';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {InformType} from '../../../../global/util/enum/InformType';
import {Person} from '../../../model/Person';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Constant} from '../../../../global/util/Constant';
import {AuthService} from '../../../service/auth/auth.service';
import {GroupParticipant} from '../../../model/GroupParticipant';
import {NotifyPostOperationComponent} from '../notify-post-operation/notify-post-operation.component';
import {SieemailService} from '../../../service/sieemail.service';
import {Sieemail} from '../../../model/Sieemail';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Dialog} from '../../../../global/util/Dialog';
import {Operation} from '../../../model/Operation';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {Uanatacasignaturelevel} from '../../../model/Uanatacasignaturelevel';
import {OperationType} from '../../../../global/util/OperationType';
import {Workflow} from '../../../model/Workflow';
import {WorkflowType} from '../../../../global/util/WorkflowType';
import {ParticipantType} from '../../../../global/util/enum/ParticipantType';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-addgroup-participant',
  templateUrl: './addgroup-participant.component.html',
  styleUrls: ['./addgroup-participant.component.css']
})
export class AddgroupParticipantComponent implements OnInit {
  public participantForm: FormGroup;
  public loading: boolean;
  public deletedParticipants: Participant[] = [];
  public participant = new Participant();
  public workflowReceived: Workflow;
  public selectedPerson = new Person();
  public people: Person[];
  public personFullName: string;
  public groupParticipant = new GroupParticipant();
  public readonly ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public readonly ROLE_PARTNER = Constant.ROLE_PARTNER;
  public readonly ROLE_ADMIN = Constant.ROLE_ADMIN;
  public readonly ROLE_USER = Constant.ROLE_USER;
  private lastParticipanttypeSelected = Constant.USER;
  private enterpriseIdSelected: number;
  public operations: Operation[] = [];
  public wasSelectedPersonAfterSearch: boolean;
  public title = 'TITLE.PARTICIPANTS';
  public entityName = 'TITLE.PARTICIPANT';
  public uanatacasignaturelevels: Uanatacasignaturelevel[] = [];
  public readonly REVIEW = OperationType.REVIEW;
  public readonly VISUALIZATION = OperationType.VISUALIZATION;
  public readonly NOTIFY = OperationType.NOTIFY;
  public readonly DIGITAL_SIGNATURE = TypeSignature.DIGITAL;
  public readonly ELECTRONIC_SIGNATURE = TypeSignature.ELECTRONIC;
  public readonly CLOUD_SIGNATURE = TypeSignature.CLOUD;
  public readonly REMOTE_SIGNATURE = TypeSignature.REMOTE;
  public readonly ANYTHING_SIGNATURE = TypeSignature.REMOTE;
  public readonly SIGNATURE_WORKFLOW = WorkflowType.SIGNATURE;
  public readonly UPLOAD_TO_IOFESIGN = WorkflowType.UPLOAD_TO_IOFESIGN;
  public readonly NOTCER = WorkflowType.NOTCER;

  constructor(private activeModal: NgbActiveModal,
              private participantService: ParticipantService,
              private formBuilder: FormBuilder,
              private modalService: NgbModal,
              public authenticationService: AuthService,
              private sieemailService: SieemailService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.createForm();
  }

  ngOnInit() {
    this.loadInitialData();
    this.setDefaultValuesOfAddedParticipant();
  }

  private loadInitialData() {
    this.loadOperations();
    this.getParticipants(this.workflowReceived);
    this.uanatacasignaturelevels = LocalStorage.getSignaturelevels();
  }

  private setDefaultValuesOfAddedParticipant() {
    this.participant.participantType = this.lastParticipanttypeSelected;
    this.participant.operationId = this.operations[0].id;
    this.participant.sendAlert = Constant.SEND_ALERT;
    this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
    this.participant.sendCompletionEmail = this.hasNotificationByDocument;
    this.participant.sendCompletionNotification = this.hasNotificationByDocument;
    this.participant._more.personFullName = '-';
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN)) {
      this.enterpriseIdSelected = this.workflowReceived.enterpriseId;
    } else {
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
    }
    this.personFullName = '';
    this.participant.addTsa = Constant.NOT_ADD_TSA;
    this.participant.sendNotification = Constant.NOT_SEND_NOTIFICATION;
    this.participant.typeSignature = this.isPresentAddManifestAndTraceability ? TypeSignature.ELECTRONIC : TypeSignature.DIGITAL;
    this.markAsUntouchedAllControls();
    this.people = [];
    switch (this.lastParticipanttypeSelected) {
      case Constant.USER:
      case Constant.INVITED_USER:
        this.wasSelectedPersonAfterSearch = false;
        break;
      case Constant.INVITED:
        this.wasSelectedPersonAfterSearch = true;
        this.participant.personId = Constant.DEFAULT_PERSON_ID;
        this.participant._more.jobDescription = '-';
        break;
    }
  }

  public save() {
    this.setValuesBefore2Save();
    if (this.isNewGroup) {
      this.register();
    } else {
      this.edit();
    }
  }

  private register() {
    this.loading = true;
    this.participantService.saveGroup(this.groupParticipant).subscribe(next => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  private edit() {
    this.loading = true;
    this.participantService.editGroup(this.groupParticipant).subscribe(next => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  get isNewGroup(): boolean {
    return !this.existSomeRegisteredParticipants;
  }

  get existSomeRegisteredParticipants(): boolean {
    return !(this.groupParticipant.participants.find(participant => participant.id !== undefined) === undefined);
  }

  private setValuesBefore2Save() {
    this.groupParticipant.workflowId = this.workflowReceived.id;
    const participants: Participant[] = this.arrayParticipant.controls.map(control => this.buildParticipantOf(control));
    this.setOrderOf(participants);
    this.addDeletedParticipantsTo(participants);
    this.groupParticipant.participants = participants;
  }

  private buildParticipantOf(control: AbstractControl): Participant {
    return {
      id: control.get('id').value,
      workflowId: null,
      operationId: control.get('operationId').value,
      personId: control.get('personId').value,
      participantType: control.get('participantType').value,
      orderParticipant: null,
      createAt: null,
      active: this.getData(control.get('active').value),
      addTsa: this.getData(control.get('addTsa').value),
      sendAlert: this.getData(control.get('sendAlert').value),
      sendWspAlert: this.getData(control.get('sendWspAlert').value),
      sendNotification: this.getData(control.get('sendNotification').value),
      sendCompletionEmail: this.getData(control.get('sendCompletionEmail').value),
      sendCompletionNotification: this.getData(control.get('sendCompletionNotification').value),
      personFullName: null,
      observation: null,
      dragRubric: this.getData(control.get('dragRubric').value),
      acceptRubricPlacement: this.getData(control.get('acceptRubricPlacement').value),
      identityValidation: this.getData(control.get('identityValidation').value),
      uploadRubric: this.getData(control.get('uploadRubric').value),
      documentTracking: this.getData(control.get('documentTracking').value),
      documentIntegrity: this.getData(control.get('documentIntegrity').value),
      typeSignature: control.get('typeSignature').value,
      signatureLevel: control.get('signatureLevel').value,
      _more: null
    };
  }

  private getData(controlValue: any): any {
    if (controlValue) {
      if (controlValue === 1 || controlValue === true) {
        return Constant.ON;
      } else {
        return Constant.OFF;
      }
    } else {
      return Constant.OFF;
    }
  }

  private setOrderOf(participants: Participant[]) {
    for (let index = 0; index < participants.length; index++) {
      participants[index].orderParticipant = index + 1;
    }
  }

  private addDeletedParticipantsTo(participants: Participant[]) {
    this.deletedParticipants.forEach(participant => participants.push(participant));
  }

  public cancel() {
    this.activeModal.close(AddgroupParticipantComponent);
  }

  public addParticipant() {
    if (this.participant.operationId === OperationType.VISUALIZATION) {
      const isLastPosition = this.workflowReceived.maxParticipants - 1 === this.arrayParticipant.length;
      if (!isLastPosition) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.ATTENTION'), this.translate.instant('MESSAGE.PARTICIPANT-IN-CHARGE-SHOULD-BE-PLACED-LAST-POSITION'));
        return;
      }
    } else if (this.isInvited && this.hasNotificateAfterUpload && this.existSomeRegisteredInvited) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.ATTENTION'), this.translate.instant('MESSAGE.INVITED-PARTICIPANT-IS-ALREADY-REGISTERED'));
      return;
    }
    this.addItem2ArrayParticipant(this.participant);
    this.participant = new Participant();
    this.setDefaultValuesOfAddedParticipant();
    this.loadOperations();
  }

  public delete(index: number) {
    const control: AbstractControl = this.arrayParticipant.at(index);
    const participant: Participant = this.buildParticipantOf(control);
    if (participant.id) {
      participant.active = Constant.INACTIVE;
      this.deletedParticipants.push(participant);
    }
    this.arrayParticipant.removeAt(index);
  }

  public search(data: any) {
    this.people = [];
    const fullname = data.target.value;
    if (fullname.length > 3) {
      this.participantService.search(this.enterpriseIdSelected, this.participant.participantType, fullname).subscribe((next: any) => {
        if (next._embedded) {
          this.people = next._embedded.people;
        }
      });
    }
  }

  get isNotFull(): boolean {
    return this.arrayParticipant.length !== this.workflowReceived.maxParticipants;
  }

  get hasnotMiniumParticipants(): boolean {
    return this.arrayParticipant.length < Constant.MINIMUM_PARTICIPANTS;
  }

  private createForm() {
    this.participantForm = this.formBuilder.group(
      {
        groupRadio: ['', [Validators.required]],
        operation: ['', [Validators.required]],
        personName: ['', [Validators.required]],
        reviewOperation: [0],
        signOperation: [1],
        tsa: [''],
        sendAlert: [''],
        identityValidation: [''],
        sendWspAlert: [''],
        sendNotification: [''],
        uanatacasignaturelevel: [''],
        sendCompletionEmail: [''],
        sendCompletionNotification: [''],
        uploadRubric: [''],
        state: [''],
        dragRubric: [''],
        acceptRubricPlacement: [''],
        documentTracking: [''],
        documentIntegrity: [''],
        arrayParticipant: this.formBuilder.array([])
      });
  }

  public onPersonChanged(personNameSelected) {
    const listElement = personNameSelected.split('-');
    const documentNumber = listElement[Constant.ZERO_INDEX].trim();
    this.selectedPerson = this.getPersonSelectedBy(documentNumber);
    if (this.selectedPerson) {
      this.participant.personId = this.selectedPerson.id;
      this.participant._more.personFullName = this.selectedPerson.fullname;
      this.participant._more.jobDescription = this.selectedPerson._more.jobDescription;
      this.wasSelectedPersonAfterSearch = true;
    } else {
      this.wasSelectedPersonAfterSearch = false;
    }
  }

  public getPersonSelectedBy(documentNumber: string): any {
    return this.people.find(person => person.documentNumber === documentNumber);
  }

  public isInvalidControl(ctrlName: string) {
    return this.participantForm.get(ctrlName).invalid && this.participantForm.get(ctrlName).touched;
  }

  public getParticipants(workflow: Workflow) {
    this.loading = true;
    this.participantService.getParticipants(workflow.id).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        const participants = next._embedded.participants;
        this.fillArrayParticipant(participants);
      }
    }, error => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.PARTICIPANT'));
    });
  }

  private fillArrayParticipant(participants: Participant[]) {
    participants.forEach(participant => this.addItem2ArrayParticipant(participant));
  }

  private addItem2ArrayParticipant(participant: Participant) {
    const control = this.formBuilder.group({
      id: [participant.id],
      personId: participant.personId,
      participantType: participant.participantType,
      personFullname: participant._more.personFullName,
      jobDescription: participant._more.jobDescription,
      operationId: participant.operationId,
      addTsa: participant.addTsa === 1 ? Constant.ADD_TSA : Constant.NOT_ADD_TSA,
      sendAlert: participant.sendAlert === 1 ? Constant.SEND_ALERT : Constant.NOT_SEND_ALERT,
      sendWspAlert: participant.sendWspAlert === 1 ? Constant.SEND_ALERT : Constant.NOT_SEND_ALERT,
      sendNotification: participant.sendNotification === 1 ? Constant.SEND_NOTIFICATION : Constant.NOT_SEND_NOTIFICATION,
      sendCompletionEmail: participant.sendCompletionEmail ? participant.sendCompletionEmail : false,
      sendCompletionNotification: participant.sendCompletionNotification ? participant.sendCompletionNotification : false,
      uploadRubric: participant.uploadRubric,
      dragRubric: participant.dragRubric,
      documentTracking: participant.documentTracking,
      documentIntegrity: participant.documentIntegrity,
      acceptRubricPlacement: participant.acceptRubricPlacement,
      identityValidation: participant.identityValidation,
      typeSignature: participant.typeSignature,
      signatureLevel: participant.signatureLevel,
      active: participant.active,
      // disableTsa: participant.disableTsa
    });
    this.arrayParticipant.push(control);
  }

  get arrayParticipant() {
    return this.participantForm.get('arrayParticipant') as FormArray;
  }

  public onItemChangeParticipantType() {
    this.markAsUntouchedAllControls();
    switch (this.participant.participantType) {
      case Constant.USER:
        this.participant.typeSignature = this.isPresentAddManifestAndTraceability ? TypeSignature.ELECTRONIC : TypeSignature.DIGITAL;
        this.wasSelectedPersonAfterSearch = false;
        break;
      case Constant.INVITED_USER:
        this.participantForm.get('personName').setValidators(Validators.compose([Validators.required]));
        this.participantForm.get('personName').updateValueAndValidity();
        this.wasSelectedPersonAfterSearch = false;
        this.participant.uploadRubric = false;
        this.participant.typeSignature = this.isPresentAddManifestAndTraceability ? TypeSignature.ELECTRONIC : TypeSignature.DIGITAL;
        break;
      case Constant.INVITED:
        this.participantForm.get('personName').clearValidators();
        this.participantForm.get('personName').updateValueAndValidity();
        this.participant._more.personFullName = '-';
        this.participant._more.jobDescription = '-';
        this.wasSelectedPersonAfterSearch = true;
        this.participant.typeSignature = this.isPresentAddManifestAndTraceability ? TypeSignature.ELECTRONIC : TypeSignature.DIGITAL;
        this.participant.personId = Constant.DEFAULT_PERSON_ID;
        break;
    }
    this.participant.operationId = this.operations[0].id;
    this.lastParticipanttypeSelected = this.participant.participantType;
    this.personFullName = '';
  }

  get isInvited() {
    return Constant.INVITED === this.participant.participantType;
  }

  get isOptBatchLoadSelected() {
    return Constant.BATCH === this.workflowReceived.batch;
  }

  get isReviewOptionSelected() {
    return Constant.REVIEW_OPTION === this.participant.operationId;
  }

  public onItemChangeTsa(checked) {
    this.participant.addTsa = checked ? Constant.ADD_TSA : Constant.NOT_ADD_TSA;
  }

  public onItemChangeSendAlert(checked) {
    this.participant.sendAlert = checked ? Constant.SEND_ALERT : Constant.NOT_SEND_ALERT;
  }

  public onItemChangeSendWspAlert(checked) {
    this.participant.sendWspAlert = checked ? Constant.SEND_ALERT : Constant.NOT_SEND_ALERT;
  }

  public onItemChangeDragRubric(checked) {
    this.participant.dragRubric = checked;
    if (!this.participant.dragRubric) {
      this.participant.acceptRubricPlacement = false;
    }
  }

  public onItemChangeSendNotification(checked) {
    this.participant.sendNotification = checked ? Constant.SEND_NOTIFICATION : Constant.NOT_SEND_NOTIFICATION;
  }

  public onItemChangeDigitalSignature(checked) {
    this.participant.typeSignature = checked;
  }

  public onItemChangeDocumentTracking(checked) {
    this.participant.documentTracking = checked;
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  private markAsUntouchedAllControls() {
    Object.values(this.participantForm.controls).forEach(control => {
      control.markAsUntouched();
    });
  }

  public getOperationDescription(operationId: number): string {
    const operation = LocalStorage.getOperations().find(operation1 => operation1.id === operationId);
    if (operation) {
      return operation.description;
    }
    return '-';
  }

  public openModalNotifyPostOperation(participantId: number) {
    this.loading = true;
    this.sieemailService.getBy(participantId).subscribe((next: any) => {
      this.loading = false;
      this.viewModalNotifyPostOperation(participantId, next._embedded.sieemail);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.NOT_FOUND === error.status) {
        this.viewModalNotifyPostOperation(participantId, new Sieemail());
      } else {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.PARTICIPANT'));
      }
    });
  }

  private viewModalNotifyPostOperation(participantId: number, sieemail: Sieemail) {
    const modalRef = this.modalService.open(NotifyPostOperationComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.participantIdReceived = participantId;
    modalRef.componentInstance.sieemailReceived = sieemail;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.PARTICIPANT'));
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.PARTICIPANT'));
      }
    });
  }

  public viewSendNotificationOpt(sendNotification: number) {
    return Constant.SEND_NOTIFICATION === sendNotification;
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  get disableSendNotification() {
    return Constant.SIE_SIGN === this.workflowReceived.type;
  }

  public drop(event: CdkDragDrop<Participant[]>) {
    moveItemInArray(this.arrayParticipant.controls, event.previousIndex, event.currentIndex);
  }

  public getBadgeTypeBy(operationType: number): string {
    switch (operationType) {
      case OperationType.SIGN:
        return 'badge-success';
      case OperationType.REVIEW:
        return 'badge-dark';
      case OperationType.VISUALIZATION:
        return 'badge-warning';
      case OperationType.NOTIFY:
        return 'badge-dark';
      default:
        return '';
    }
  }

  get onlySignOption(): boolean {
    return Constant.SIE_SIGN === this.workflowReceived.type;
  }

  get workflowtypeDesc(): string {
    return LocalStorage.getWorkflowtypes().find(value => this.workflowReceived.type === value.id).description;
  }

  typeSignatureChange(): void {
    switch (this.participant.typeSignature) {
      case TypeSignature.DIGITAL:
        this.participant.addTsa = Constant.NOT_ADD_TSA;
        this.participant.sendAlert = Constant.SEND_ALERT;
        this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
        this.participant.sendCompletionEmail = this.hasNotificationByDocument;
        this.participant.sendCompletionNotification = this.hasNotificationByDocument;
        this.participant.documentIntegrity = false;
        break;
      case TypeSignature.CLOUD:
        this.participant.addTsa = Constant.ADD_TSA;
        this.participant.sendAlert = Constant.SEND_ALERT;
        this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
        this.participant.sendCompletionEmail = this.hasNotificationByDocument;
        this.participant.sendCompletionNotification = this.hasNotificationByDocument;
        this.participant.documentIntegrity = false;
        break;
      case TypeSignature.REMOTE:
        this.participant.addTsa = Constant.NOT_ADD_TSA;
        this.participant.sendAlert = Constant.SEND_ALERT;
        this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
        this.participant.sendCompletionEmail = this.hasNotificationByDocument;
        this.participant.sendCompletionNotification = this.hasNotificationByDocument;
        this.participant.signatureLevel = this.uanatacasignaturelevels[Constant.ZERO_INDEX].id;
        this.participant.documentIntegrity = false;
        break;
      case TypeSignature.ELECTRONIC:
        this.participant.sendAlert = Constant.SEND_ALERT;
        this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
        this.participant.sendCompletionEmail = this.hasNotificationByDocument;
        this.participant.sendCompletionNotification = this.hasNotificationByDocument;
        this.participant.addTsa = Constant.NOT_ADD_TSA;
        this.participant.sendNotification = Constant.NOT_SEND_NOTIFICATION;
        this.participant.uploadRubric = false;
        break;
      default:
        Dialog.show(InformType.Danger, 'Error', this.translate.instant('MESSAGE.OPTIONS-ERROR'));
        break;
    }
  }

  descriptionOfSignatureLevel(signatureLevel: number): string {
    if (signatureLevel !== null) {
      if (signatureLevel !== 0) {
        return this.uanatacasignaturelevels.find(uanatacasignaturelevel => uanatacasignaturelevel.id === signatureLevel).name;
      }
      return '-';
    } else {
      return '-';
    }
  }

  description(typeSignature: number): string {
    switch (typeSignature) {
      case TypeSignature.DIGITAL:
        return this.translate.instant('TITLE.DIGITAL-SIGNATURE');
      case TypeSignature.ELECTRONIC:
        return this.translate.instant('TITLE.GRAPHIC-SIGNATURE');
      case TypeSignature.CLOUD:
        return this.translate.instant('TITLE.ONESIGN-SIGNATURE');
      case TypeSignature.REMOTE:
        return this.translate.instant('TITLE.REMOTE-SIGNATURE');
      default:
        return '-';
    }
  }

  typeOperationChange(): void {
    const operationId = this.participant.operationId;
    switch (operationId) {
      case OperationType.SIGN:
        this.participant.typeSignature = this.isPresentAddManifestAndTraceability ? TypeSignature.ELECTRONIC : TypeSignature.DIGITAL;
        this.typeSignatureChange();
        break;
      case OperationType.REVIEW:
        this.participant.typeSignature = TypeSignature.ANYTHING;
        this.participant.sendAlert = Constant.SEND_ALERT;
        this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
        this.participant.sendCompletionEmail = this.hasNotificationByDocument;
        this.participant.sendCompletionNotification = this.hasNotificationByDocument;
        this.participant.addTsa = Constant.NOT_ADD_TSA;
        this.participant.sendNotification = Constant.NOT_SEND_NOTIFICATION;
        this.participant.uploadRubric = false;
        break;
      case OperationType.VISUALIZATION:
        this.participant.typeSignature = TypeSignature.ANYTHING;
        this.participant.sendAlert = Constant.SEND_ALERT;
        this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
        this.participant.addTsa = Constant.NOT_ADD_TSA;
        this.participant.sendNotification = Constant.NOT_SEND_NOTIFICATION;
        this.participant.uploadRubric = false;
        break;
      case OperationType.NOTIFY:
        if (this.workflowReceived.notifyAfterUpload) {
          this.participant.sendAlert = Constant.NOT_SEND_ALERT;
          this.participant.sendWspAlert = Constant.NOT_SEND_ALERT;
        }
        this.participant.typeSignature = TypeSignature.ANYTHING;
        this.participant.addTsa = Constant.NOT_ADD_TSA;
        this.participant.sendNotification = Constant.NOT_SEND_NOTIFICATION;
        this.participant.uploadRubric = false;
        break;
    }
  }

  onItemChangeDocumentIntegrity(checked: any) {
    this.participant.documentIntegrity = checked;
  }

  onItemChangeAcceptRubricPlacement(checked: any) {
    this.participant.acceptRubricPlacement = checked;
  }

  onItemChangeIdentityValidation(checked: any) {
    this.participant.identityValidation = checked;
  }

  get signatureOperationSelected() {
    return OperationType.SIGN === this.participant.operationId;
  }

  get reviewOperationSelected() {
    return OperationType.REVIEW === this.participant.operationId;
  }

  get visualizationOperationSelected() {
    return OperationType.VISUALIZATION === this.participant.operationId || this.workflowReceived.notifyAfterUpload;
  }


  get hasNotificationByDocument(): boolean {
    return this.workflowReceived.notificationByDocument;
  }

  get hasNotificateAfterUpload(): boolean {
    return this.workflowReceived.notificateAfterUpload;
  }

  get hasSend2MailAfterUpload(): boolean {
    return this.workflowReceived.send2MailAfterUpload;
  }

  public isFreelySignature(workflow: Workflow): boolean {
    return workflow.freelySignature;
  }

  /**
   * Carga los tipos de operación en función a si tiene el permiso de revisión o no
   */
  loadOperations(): void {
    this.operations = LocalStorage.getOperations();
    if (WorkflowType.UPLOAD_TO_IOFESIGN === this.workflowReceived.type
      || WorkflowType.NOTCER === this.workflowReceived.type) {
      if (this.workflowReceived.send2Visualization) {
        this.removeOperation(OperationType.REVIEW);
        if (!this.isInvited) {
          this.removeOperation(OperationType.VISUALIZATION);
          if (this.workflowReceived.notifyAfterUpload || this.workflowReceived.scheduledNotify) {
            this.removeOperation(OperationType.SIGN);
          }
        }
        if (this.isInvited && this.workflowReceived.send2Visualization) {
          this.removeOperation(OperationType.NOTIFY);
        }
      } else {
        this.removeOperation(OperationType.NOTIFY);
        this.removeOperation(OperationType.VISUALIZATION);
      }
    } else {
      // TODO definir código de permiso
      const authority1 = true;
      if (!this.isInvited || !this.workflowReceived.send2Visualization || !authority1) {
        this.removeOperation(OperationType.NOTIFY);
        this.removeOperation(OperationType.VISUALIZATION);
      }
    }
  }

  private removeOperation(operationId: number) {
    const reviewIndex = this.operations.findIndex(value => value.id === operationId);
    this.operations.splice(reviewIndex, 1);
  }

  get existSomeRegisteredInvited(): boolean {
    return this.arrayParticipant.value.find(value => value.participantType === ParticipantType.Invited) !== undefined;
  }

  get dragRubricChecked() {
    return !this.participant.dragRubric;
  }

  get isPresentAddManifestAndTraceability() {
    const addManifestChecked = this.workflowReceived._more.workflowMoreCondition ? this.workflowReceived._more.workflowMoreCondition.checkedAddManifest : false;
    const addTraceabilityChecked = this.workflowReceived._more.workflowMoreCondition ? this.workflowReceived._more.workflowMoreCondition.checkedAddTraceability : false;
    return addManifestChecked || addTraceabilityChecked;
  }
}
